<template>
  <!-- ===== 頂部玻璃 Banner（底圖+文案） ===== -->
  <section class="purchase-hero-glass">
    <div class="purchase-hero__overlay"></div>

    <div class="purchase-hero__inner container">
      <h1 class="purchase-hero__title">
        Web3 項目 <span class="hl">速成</span> 課程（優越 3.0）
      </h1>
      <p class="purchase-hero__sub">
        學習用 <strong>2 個月</strong> 成為一個 — 從 0 基礎到 Web3 個人創業者
        <a href="#gain" class="purchase-hero__link hl-text">祕訣</a>
      </p>


    </div>
  </section>

  <!-- ===== 柔金底課程卡片 Section ===== -->
  <OfferGoldCard />
  <!-- ===== 白色背景：宣言 + 圖片 + 影片 ===== -->
  <section class="declare-section">
    <div class="container">
      <div class="hero-declare">
        <h2 class="hero-declare__title">只要您願意堅持，肯定能學</h2>
        <p class="hero-declare__sub">
          學習最好的時間，就是現在！因為未來的你肯定比今天更沒有時間！
        </p>
        <p class="hero-declare__cta">⬇ 你能獲得 ⬇</p>
      </div>

      <figure class="hero-media">
        <img src="/images/giftpack.png" alt="課程內容拼貼與教學頁面示意" />
      </figure>

      <section class="hero-video-section">
        <h2 class="hero-video-title">＝ 院長教你怎麼學 ＝</h2>
        <p class="hero-video-sub">(YouTube 影片👇，部分地區請留意網絡環境)</p>

        <div class="hero-video-box">
          <div class="aspect-video">
            <iframe src="https://www.youtube.com/embed/7-GD_8mlO9A" title="課程導覽" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
          </div>
        </div>
      </section>
    </div>
  </section>

  <!-- ===== 課程綱要（完整版本） ===== -->
  <section class="syllabus-section">
    <div class="syllabus-container">
      <h2 class="syllabus-title">課程綱要（完整內容）</h2>

      <!-- 1.0 -->
      <details open class="syllabus-item">
        <summary>⬇️ 1.0 課程結構（Solidity / EVM）</summary>

        <div class="syllabus-block">
          <h4>綱要</h4>
          <ul class="syllabus-list">
            <li>📖 前言 &amp; 學前計劃【一定要看】</li>
          </ul>
        </div>

        <div class="syllabus-block">
          <h4>第一章（基礎技能篇）</h4>
          <ul class="syllabus-list">
            <li>📖 區塊鏈必備代碼編輯器 VScode + Remix插件</li>
            <li>📖 Remix 快速使用手冊</li>
            <li>📖 快速學習solidity基礎語法</li>
            <li>📖 學習前必備的的環境安裝(vue + nodejs )</li>
            <li>📖 Hardhat部署工具安裝和教你用該工具部署一个合約</li>
            <li>📖 Openzeppelin 庫快速介绍和基础用法</li>
            <li>📖 用openzeppelin发布自己的ERC20 憑證</li>
            <li>📖 用openzeppelin发布自己一個有功能的NFT （ERC721）</li>
            <li>📖 代理合约介紹和使用</li>
            <li>📖 公开合约方法</li>
          </ul>
        </div>

        <div class="syllabus-block">
          <h4>第二章（模板輪子代碼篇）</h4>
          <ul class="syllabus-list">
            <li>📖 Vue構建Dapp模板介紹</li>
            <li>📖 用前端vue框架連結鏈端，並且發起修改數據 以及數據刷新</li>
            <li>📖 快速开发白名单合约（合約篇）</li>
            <li>📖 快速开发白名单合约（前端對接篇）</li>
            <li>📖 快速開發白名單 Claim功能（合約）</li>
            <li>📖 快速開發白名單 Claim功能（前端對接）</li>
            <li>📖 快速開發空投合約輪子工具（合約）</li>
            <li>📖 Farm 流動性挖礦（合約）</li>
            <li>📖 sToken 治理憑證(合約)</li>
          </ul>
        </div>

        <div class="syllabus-block">
          <h4>第三章（實例NFT33債券項目鏈接+前端開發篇）</h4>
          <ul class="syllabus-list">
            <li>📖 实例項目介紹</li>
            <li>📖 合約文件結構</li>
            <li>📖 鏈端合約部分1</li>
            <li>📖 鏈端合約部分2</li>
            <li>📖 实例项目合約部署</li>
            <li>📖 前端與智能結合的連接1</li>
            <li>📖 前端與智能結合的連接2</li>
            <li>📖 前端與智能結合的連接3</li>
            <li>📖 前端與智能合約的連接4</li>
            <li>📖 利用4everland.org 去中心化方式把自己項目上線一個域名</li>
          </ul>
        </div>

        <div class="syllabus-block">
          <h4>【贈送】屯比特幣 之 9神-Ahr999 （YouTube）1-15集</h4>
          <ul class="syllabus-list">
            <li>📖 1 - 15集（課程名稱、略）</li>
          </ul>
        </div>

        <div class="syllabus-block">
          <h4>【贈送】Web3小白养成之路｜Web3赛道大盘点（YouTube）</h4>
          <ul class="syllabus-list">
            <li>📖 1 - 3集（課程名稱、略）</li>
          </ul>
        </div>

        <div class="syllabus-block">
          <h4>【贈送】Discord運營搭建教學（YouTube）</h4>
          <ul class="syllabus-list">
            <li>📖 略1 - 2集（課程名稱、略）</li>
          </ul>
        </div>

        <div class="syllabus-block">
          <h4>【贈送】Web3加密101百科系列（YouTube）</h4>
          <ul class="syllabus-list">
            <li>📖 略1 - 6集（課程名稱、略）</li>
          </ul>
        </div>
      </details>

          <!-- 🔥 第一張分隔圖：1.0 → 2.0 -->
    <div class="syllabus-separator">
      <img src="/images/section-divider-1.png" alt="divider" />
    </div>

      <!-- 2.0 -->
      <details open class="syllabus-item">
        <summary>⬇️ 2.0 課程結構（Solana）</summary>

        <div class="syllabus-block">
          <h4>鏈端入門</h4>
          <ul class="syllabus-list">
            <li>📖 前言【Solana應用開發需要懂得什麼技能】</li>
            <li>📖 Solana 10大賬戶類型</li>
            <li>📖 Solana鏈與Ethereum鏈的區別（如Ethereum）</li>
            <li>📖 全能編輯器 Solana IDE (slog.io)</li>
            <li>📖 solana-cli (安裝與介紹)</li>
            <li>📖 創建SPL標準的Token</li>
            <li>📖 SPL Token 名稱和Logo更新</li>
            <li>📖 創建SPL標準的NFT</li>
            <li>📖 Seahorse ( Python ) 變量的增刪改查 ｜管理員權限添加</li>
            <li>📖 Seahorse ( Python ) 數組的增刪改查 ｜學生添加刪除系統</li>
            <li>📖 Seahorse ( Python ) PDAs代替Mapping ｜製作地圖狀態</li>
            <li>📖 Seahorse ( Python ) PDAs帳號存取Sol ｜買NFT扣sol功能</li>
            <li>📖 Seahorse ( Python ) PDAs帳號存取SPL-Token ｜買NFT扣SPL</li>
            <li>📖 Seahorse ( Python ) CPIs跨程序調用｜攻擊合約調用其他合約</li>
            <li>📖 Seahorse ( Python ) Bump｜用PDA進行簽名轉帳</li>
            <li>📖 學會看區塊鏈瀏覽器</li>
            <li>📖 本地測試網部署</li>
          </ul>
        </div>

        <div class="syllabus-block">
          <h4>腳本測試</h4>
          <ul class="syllabus-list">
            <li>📖 腳本依賴庫介紹和安裝</li>
            <li>📖 @solana/web3.js 之 賬戶管理</li>
            <li>📖 @solana/web3.js 之 交易處理</li>
            <li>📖 @solana/web3.js 之 與智能合約交互</li>
            <li>📖 @solana/web3.js 之 事件監聽1</li>
            <li>📖 @solana/web3.js 之 RPC 請求</li>
            <li>📖 @solana/web3.js 之 序列和反序列</li>
            <li>📖 @solana/spl-token 之 創建spl-token</li>
            <li>📖 @solana/spl-token 之 转账SPL token</li>
            <li>📖 @solana/spl-token 之 事件監聽2</li>
            <li>📖 【重點】🔥 anchor 之 與智能合約交互</li>
            <li>📖 anchor 之 監聽Sol並且轉帳Sol</li>
            <li>📖 anchor 之 綜合案例</li>
          </ul>
        </div>

        <div class="syllabus-block">
          <h4>鏈端進階</h4>
          <ul class="syllabus-list">
            <li>📖 利用Seahorse寫一個拍賣程序 ( 鏈端智能合約 )</li>
            <li>📖 拍賣程序auction 的Bug修復（鏈端智能合約）</li>
          </ul>
        </div>

        <div class="syllabus-block">
          <h4>前端對接</h4>
          <ul class="syllabus-list">
            <li>📖 前端連接錢包</li>
            <li>📖 實戰項目 - 項目介紹</li>
            <li>📖 實戰項目1</li>
            <li>📖 實戰項目2</li>
            <li>📖 實戰項目3</li>
          </ul>
        </div>
      </details>

    <!-- 🔥 第二張分隔圖：2.0 → 3.0 -->
    <div class="syllabus-separator">
      <img src="/images/section-divider-2.png" alt="divider" />
    </div>

      <!-- 3.0 -->
      <details open class="syllabus-item">
        <summary>⬇️ 3.0 課程結構（Solana鏈-自動化腳本）</summary>

        <div class="syllabus-block">
          <h4>綱要</h4>
          <ul class="syllabus-list">
            <li>📖 前言</li>
          </ul>
        </div>

        <div class="syllabus-block">
          <h4>第一章 （Jupiter API）</h4>
          <ul class="syllabus-list">
            <li>📖 Jupiter 聚合API介紹</li>
            <li>📖 準備工作（依賴安裝）</li>
            <li>📖 獲取報價</li>
            <li>📖 建立交易</li>
            <li>📖 發送上鏈</li>
            <li>📖 如何提高優先費</li>
            <li>📖 JUP其它常用API</li>
          </ul>
        </div>

        <div class="syllabus-block">
          <h4>第二章 （Pumpportal API）</h4>
          <ul class="syllabus-list">
            <li>📖 Pumpportal.fun API 介紹</li>
            <li>📖 監控新Token</li>
            <li>📖 監控某Token 價格+ K線生成</li>
            <li>📖 用API監控某大哥的全部交易</li>
            <li>📖 用Pumpportal建立於發送交易</li>
          </ul>
        </div>

        <div class="syllabus-block">
          <h4>第三章 （框架模板）</h4>
          <ul class="syllabus-list">
            <li>📖 機器人腳本框架模板1</li>
            <li>📖 機器人腳本框架模板2</li>
            <li>📖 機器人腳本框架模板3</li>
            <li>📖 機器人腳本框架模板4</li>
          </ul>
        </div>

        <div class="syllabus-block">
          <h4>第四章 （實戰策略）</h4>
          <ul class="syllabus-list">
            <li>📖 實戰開發1</li>
            <li>📖 實戰開發2</li>
          </ul>
        </div>
      </details>
    </div>
  </section>

  <!-- ===== 聯繫院長 Section ===== -->
  <section class="contact-section">
    <div class="contact-container">
      <h2 class="contact-title">聯繫院長</h2>

      <div class="contact-block">
        <p class="contact-label">■ 院長郵箱：</p>
        <p class="contact-email">web3schoolservice@gmail.com</p>
      </div>

      <div class="contact-block">
        <p class="contact-label">■ 院長 Discord：</p>
        <p class="contact-discord">gda_master</p>
      </div>
    </div>
  </section>

  <!-- ===== CTA Banner（金色文字） ===== -->
  <section class="cta-banner">
    <h2>名額有限，倒計時結束前立即加入</h2>
  </section>

  <!-- ===== 柔金底課程卡片 Section ===== -->
  <OfferGoldCard />

  <!-- ===== 在這裡，我們將給你一個「快速發布 Dapp」的方法 ===== -->
  <section class="dapp-method-band">
    <div class="dapp-method__wrap">
      <h2 class="dapp-method__title">
        在這裡，我們將給你一個 <span class="hl-gold">快速</span> 發布一個自己的 Dapp 方法
      </h2>

      <p class="dapp-method__p">
        這在這裡，我們將為你提供快速發布自己的 Dapp 的方法。
      </p>

      <p class="dapp-method__p">
        本網絡課程由創業者為創業者打造，專為 Web3 從業人員以及希望進入這個行業並發布自己創業項目的朋友設立。
      </p>

      <p class="dapp-method__p">
        透過這個課程，你可以以最快的速度發布自己的 DApp 創業項目，並利用「Web3 富翁學院同學會」社區資源進行相互合作。
      </p>
    </div>
  </section>

  <!-- =============== 痛點三段 Section（與圖片一致） =============== -->
  <section class="painstrip">
    <div class="painstrip__inner">
      你是否有以下煩惱?
    </div>
  </section>

  <section class="painbody">
    <div class="painbody__wrap">
      <h2 class="painbody__title">
        你是否覺得項目方割韭菜很爽，自己也想做項目？
      </h2>

      <ul class="painlist">
        <li><span>想要學智能合約，卻不知道如何下手？</span></li>
        <li><span>自己連代碼都沒接觸過，覺得太難，不敢想像？</span></li>
        <li><span>35 歲中年危機，想換個行業發展？</span></li>
        <li><span>知道項目方賺錢！但是完全不知道項目方如何從 0 變 1，一頭霧水？</span></li>
        <li><span>有項目的公開代碼，但缺不會部署？</span></li>
      </ul>

      <p class="painbody__sub">
        又或者，單純想學一個高薪技能—智能合約開發，然後上班拿個高薪？
      </p>
    </div>
  </section>

  <section class="solutionband">
    <div class="solutionband__wrap">
      <h3 class="solutionband__title">以上問題都有一個強大模版助你解決</h3>
      <p class="solutionband__p">
        一旦學習你就可以快速迭代發佈你想做的項目，這個模版能夠使你快速搭建前端和鏈端，
        以及快速部署開發自己的 Dapp 項目，讓你在 Web3 賺錢成為可能。
      </p>
      <p class="solutionband__p">
        我們把從 0→1 的步驟拆解為可執行的路徑與實作清單，幫你走出「不知道怎麼開始」的第一步。
      </p>
    </div>
  </section>

  <!-- ===== 上圖下文（全方位教學） ===== -->
  <section class="teach-block">
    <div class="teach__wrap">
      <!-- 圖片（上） -->
      <figure class="teach__figure">
        <!-- 替換成你的圖片路徑 -->
        <img src="../../public/images/teach-collage.png" alt="全方位教學 - 技術棧與人物合成圖" />
      </figure>

      <!-- 文案（下） -->
      <div class="teach__content">
        <p>
          我用了很長的時間，靠我所能學習了關於一個 DeFi、GameFi、NFT 的一系列流程和全部必要的技能，也學習如何搭建
          Discord 等社區。犯過很多錯，也踩過很多坑。
        </p>
        <p>
          因此我創作了這套最系統的課程，讓學員不再重複同樣的彎路。
        </p>
        <p>
          其實當時的我，也跟你現在的狀況很像：沒有任何編程基礎與邏輯基礎，只有一些炒幣經驗；在現實壓力與迷茫之下，仍想抓住轉型機會。
        </p>
        <p>
          但我沒有放棄。我相信自己能掌握這些技能。於是持續學習與實作，在區塊鏈公司中不斷仿做市場項目、吸收經驗，逐步形成方法論。
        </p>
        <p>
          在工作中反覆測試與總結失敗，最終把流程簡化成可複用的框架：從前端到鏈端，快速搭建並迭代一個完整 Dapp。
        </p>
        <p>
          為了分享給更多人，我整理成系統課程與教學，希望幫你用最短時間走到正確路徑上。
        </p>
      </div>
    </div>
  </section>


  <!-- Thanks Masonry -->
  <section class="thanks">
    <div class="thanks__wrap">
      <h2 class="thanks__title">下圖是一些學員朋友的感謝</h2>

      <!-- 小箭頭 -->
      <div class="thanks__arrows" aria-hidden="true">
        <svg viewBox="0 0 24 24" class="arr">
          <path d="M7 10l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <svg viewBox="0 0 24 24" class="arr">
          <path d="M7 10l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <svg viewBox="0 0 24 24" class="arr">
          <path d="M7 10l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>

      <!-- Masonry 容器 -->
      <div class="thanks__masonry">
        <article v-for="(t, i) in thanks" :key="i" class="card">
          <figure class="card__media">
            <img :src="t.src" :alt="t.alt" loading="lazy" />
            <figcaption class="card__cap" v-html="t.caption"></figcaption>
          </figure>
        </article>
      </div>

      <div class="thanks__more">……還有很多</div>
    </div>
  </section>

  <!-- 創業者心得（白底段落） -->
  <section class="founder-note">
    <div class="founder-note__wrap">
      <p>
        在個人 web3 創業者的領域，<strong>低成本、速度快</strong>，都是你的優勢。
      </p>
      <p>
        我以前接觸過 web2 的大廠，他們的效率往往因為公司過大，一個項目非常多人去推進、立項、開會、調研、各種流程，
        到開發的時候已經過了 <strong>2 個月</strong>了。
      </p>
      <p>
        而個人 web3 創業者，做同樣的項目，只要你擁有我們的 <strong>Dapp 網站前端開發模板 + 智能合約開發模板 + Discord 運營基礎</strong>，
        你就可以快速推進項目，甚至 <strong>1 個月內</strong>就能在市場嘗試這個方案是否可行，大大縮短了時間成本。
      </p>
      <p>
        而我現在用模版開發一個 Web3 項目，可能只需要 <strong>1–2 個星期</strong>。其實我也是普通人，都是艱辛的從 0 開始學習。
      </p>
      <p>
        如果我能做到，<strong>你也可以</strong>。不過跟我不一樣的是，現在你已經不需要像我當初那樣盲人摸象了。
      </p>
    </div>
  </section>

  <!-- 行動力橫幅（黑底金字） -->
  <section class="painstrip">
    <div class="painstrip__inner" style="font-size: 22px;">
      這些方法絕不僅是對我有效，<span class="gold">只要你是一個有執行力並且想成功的人</span>，你也能學會
    </div>
  </section>

  <!-- ===== 美观版｜你將學到什麼 ===== -->
  <section class="learn-pro">
    <div class="learn-pro__wrap">
      <header class="learn-pro__head">
        <span class="pill">課程重點</span>
        <h2 class="learn-pro__title">這套課程你將會學到什麼？</h2>
        <p class="learn-pro__sub">用模板 + 腳本 + 架構意識，快速把想法落地成真正可運行的 DApp</p>
      </header>

      <div class="learn-pro__grid">
        <!-- 左：重點卡片 -->
        <div class="learn-pro__left">
          <article class="lp-card">
            <div class="lp-card__icon">
              <!-- 火焰 -->
              <svg viewBox="0 0 24 24">
                <path d="M13.5 2s.5 2-1.5 4-1 4 1 5 3 2 3 4a4 4 0 1 1-8 0c0-3 2-4 2-6 0-2-2-3-2-6 0 0 4 1 5.5-1z"
                  fill="currentColor" />
              </svg>
            </div>
            <div class="lp-card__body">
              <h3 class="lp-card__title">高效開發技巧</h3>
              <ul class="lp-card__list">
                <li>運用前端 / 鏈端模板與現成代碼庫，<strong>在最短時間內</strong>開發出 DApp。</li>
                <li>熟悉「質押挖礦、流動性挖礦、白名單系統、預言機、拍賣、抽獎」等典型模塊，<strong>顯著減低工時</strong>。</li>
              </ul>
            </div>
          </article>

          <article class="lp-card">
            <div class="lp-card__icon">
              <!-- 連結 -->
              <svg viewBox="0 0 24 24">
                <path d="M10 14l4-4m-6 8l-2 2a4 4 0 0 1-6-6l2-2m16 0l2-2a4 4 0 1 0-6-6l-2 2" stroke="currentColor"
                  stroke-width="2" fill="none" stroke-linecap="round" />
              </svg>
            </div>
            <div class="lp-card__body">
              <h3 class="lp-card__title">鏈端交互腳本開發</h3>
              <ul class="lp-card__list">
                <li>打造自動化任務、搶單、跟單腳本，掌握與鏈的穩定交互。</li>
                <li>實作「一鍵創建 Token」等小工具，<strong>提升迭代速度</strong>與穩定度。</li>
              </ul>
            </div>
          </article>

          <article class="lp-card">
            <div class="lp-card__icon">
              <!-- 結構 -->
              <svg viewBox="0 0 24 24">
                <path d="M12 3v18M3 12h18M7 7h4v4H7zM13 13h4v4h-4z" fill="currentColor" />
              </svg>
            </div>
            <div class="lp-card__body">
              <h3 class="lp-card__title">項目架構意識</h3>
              <ul class="lp-card__list">
                <li>把需求拆成「前端 / 鏈端 / 腳本 / 運營」四層，<strong>先設計、再開發</strong>。</li>
                <li>收到需求後能立即規劃出可落地的專案骨架與待辦清單。</li>
              </ul>
            </div>
          </article>

          <p class="learn-pro__note">
            這是一門<strong>面向開發者</strong>的實戰課程：不講空話、不包裝，需要你動手完成每個任務。
          </p>
        </div>

        <!-- 右：拼貼圖 + 徽章 -->
        <aside class="learn-pro__right">
          <div class="mock">
            <img class="mock__img" src="../../public/images/giftpack.png" alt="課程拼貼示意" loading="lazy" />
            <span class="badge">HOT</span>
          </div>
          <p class="mock__cap">含完整講義、代碼範例與專案模板（可直接改造成你的產品）</p>
        </aside>
      </div>
    </div>
  </section>

  <!-- 行動力橫幅（黑底金字） -->
  <section class="painstrip">
    <div class="painstrip__inner">
      現在加入課程，這就是你可以得到的...
    </div>
  </section>

  <!-- ================== 課程卡片 Section（EVM + Solana） ================== -->
  <section class="course-sections">
    <div class="course-wrap">

      <!-- 1) EVM / Solidity -->
      <article class="course-card">
        <div class="course-media">
          <img src="../../public/images/course-solidity.png" alt="Solidity 課程封面" loading="lazy">
        </div>

        <div class="course-body">
          <header class="course-head">
            <h3 class="course-title">
              EVM以太坊系列 - Solidity
              <span class="price">｜價值US$3800</span>
            </h3>
            <p class="course-sub">( Web3 項目速成課程1.0 )</p>
          </header>

          <p class="course-intro">
            <span class="check" aria-hidden="true">✔</span>
            這是一個全方位的Web3實戰教學，適用於EVM虛擬機的區塊鏈，從
            <strong>0基礎開始</strong>、逐步深入，適合小白學習並快速掌握開發技能。
          </p>

          <h4 class="course-section">教程內容包括：</h4>

          <div class="course-block">
            <div class="course-label">「基礎篇」：</div>
            <p class="course-text">
              介紹必備常用的工具和框架，如編譯與部署、Hardhat開發框架、安全框架OpenZeppelin、Vue前端、ethers.js與Solidity語法特性，附帶HTML和JS語法要點，幫你完成開發系統並連通前端。
            </p>
          </div>

          <div class="course-block">
            <div class="course-label">「模塊篇」：</div>
            <p class="course-text">
              學習如何利用常見的代碼模塊快速打通項目：<strong>質押挖礦、流動性挖礦、白名單機制、白名單鑄造、空投</strong>、<strong>治理憑證（sToken）</strong>、<strong>NFT系列</strong>
              和 <strong>ERC20憑證</strong> 等，帶你用一套模塊完成從 0→1 的主線開發，顯著提升開發效率並降低開發工時。
            </p>
          </div>

          <div class="course-block">
            <div class="course-label">「實戰篇」：</div>
            <p class="course-text">
              透過實際項目（NFT+DeFi 2.0）的完整開發流程，掌握前端串接到鏈端的完整方法，每個階段附帶收斂任務與檢查清單，幫你建立完整的專案感知、路線與風險控制能力。
            </p>
          </div>

          <p class="course-link">附送教學電子代碼</p>
          <p class="course-ps">
            ps：當你學完這部分時候，已經可以獨立開發項目了，說實在，項目實作碼部署出去都能兌現「爽賺美刀」，在這裡，白送你！！
          </p>
        </div>
      </article>

      <!-- 2) Solana / Seahorse -->
      <article class="course-card">
        <div class="course-media">
          <img src="../../public/images/course-solana.png" alt="Solana & Seahorse 課程封面" loading="lazy">
        </div>

        <div class="course-body">
          <header class="course-head">
            <h3 class="course-title">
              Solana區塊鏈系列 - Seahorse
              <span class="price">｜價值US$3800</span>
            </h3>
            <p class="course-sub">( Web3 項目速成課程2.0 )</p>
          </header>

          <p class="course-intro">
            <span class="check" aria-hidden="true">✔</span>
            這是一個全面的Solana開發教學，從<strong>0基礎開始</strong>、逐步深入，適合新手快速掌握
            DApp開發技能。
          </p>

          <h4 class="course-section">教程內容包括：</h4>

          <div class="course-block">
            <div class="course-label">「入門篇」：</div>
            <p class="course-text">
              介紹Solana常用開發環境與特性，帶你掌握 <strong>Solana 10大帳戶類型</strong>、Solana與Ethereum鏈的差別，完整體驗 <strong>Solana
                IDE（slog.io）</strong>、<strong>solana-cli</strong>等工具使用流程，並實操掌握
              SPL標準的Token和NFT、掌握<strong>Seahorse（Python）</strong>
              的數據結構與賬戶管理、PDA等映射與Mapping。熟練掌握SPL-Token、CPI跨程序調用、Bump等特性。
            </p>
          </div>

          <div class="course-block">
            <div class="course-label">「腳本篇」：</div>
            <p class="course-text">
              介紹鏈端常見交互腳本，深入掌握 <strong>@solana/web3.js</strong> 與 <strong>@solana/spl-token</strong>
              的高頻用法，也包括帳戶管理、交易與簽名、批量處理、事件監聽、RPC請求、數據序列化/反序列化等實務。
              另外會帶你使用 <strong>Anchor</strong> 框架串接智能合約交互，並實戰Solana上的完整工作流。
            </p>
          </div>

          <div class="course-block">
            <div class="course-label">「實戰篇」：</div>
            <p class="course-text">
              學會如何利用Seahorse開發拍賣程序，並修復拍賣程序中的Bug，掌握複雜合約的開發和排查技巧。
            </p>
          </div>

          <div class="course-block">
            <div class="course-label">「對接篇」：</div>
            <p class="course-text">
              學會如何在前端應用中連接Solana錢包，實戰頁面連接與轉賬，深入了解鏈端介面設計與實戰的交接流程。
            </p>
          </div>

          <p class="course-link">附送教學電子代碼</p>
          <p class="course-ps">
            ps：當你學完這部分時候，已經可以獨立開發項目了，說實在，項目實作碼部署出去都能兌現「爽賺美刀」，在這裡，白送你！！
          </p>
        </div>
      </article>

      <!-- 3) Solana 系列：自動化下單腳本（沿用同一套 course-card 樣式） -->
      <article class="course-card">
        <div class="course-media">
          <!-- 換成你的實際封面圖路徑 -->
          <img src="../../public/images/course-solana-bot.png" alt="Solana 自動化下單腳本課程封面" loading="lazy">
        </div>

        <div class="course-body">
          <header class="course-head">
            <h3 class="course-title">
              Solana系列 - 自動化下單腳本
              <span class="price">｜價值US$3800</span>
            </h3>
            <p class="course-sub">( Web3 項目速成課程3.0 )</p>
          </header>

          <p class="course-intro">
            <span class="check" aria-hidden="true">✔</span>
            這是一個專注於 <strong>Solana 鏈上自動化交易腳本</strong> 開發的進階課程，
            從基礎 API 使用到完整 <strong>機器人架構設計</strong>，適合已有 Solana 開發經驗的
            學員快速掌握自動化交易技術。
          </p>

          <h4 class="course-section">教程內容包括：</h4>

          <div class="course-block">
            <div class="course-label">「Jupiter API 篇」：</div>
            <p class="course-text">
              學習使用 <strong>Jupiter 聚合 API</strong> 進行行情獲取、交易路徑選擇、交易構建與發送上鏈，
              並掌握提高成交優先級與費用控制的技巧。
            </p>
          </div>

          <div class="course-block">
            <div class="course-label">「Pump API 篇」：</div>
            <p class="course-text">
              探索 <strong>Pump 平台 API</strong> 的即時能力，包括監控新幣、代幣價格、大戶交易動向與
              事件觸發，並實現自動化下單與風控。
            </p>
          </div>

          <div class="course-block">
            <div class="course-label">「機器人腳本架構模版」：</div>
            <p class="course-text">
              從基礎到進階，學習多模組機器人腳本架構設計，涵蓋 <strong>錯誤處理、重試機制、併發與排程、
                策略調度、執行隊列與監控</strong>，打造可維護、可觀測的高效能化架構。
            </p>
          </div>

          <div class="course-block">
            <div class="course-label">「策略實戰」：</div>
            <p class="course-text">
              結合 <strong>Jupiter / Pump API</strong> 與前述架構模版，完成多種自動化交易策略的
              開發、迭代與優化，並加入回測與真實交易環境中的參數調優。
            </p>
          </div>

          <p class="course-link">附送教學代碼</p>
          <p class="course-ps">
            ps：當你學完這部分時候，<strong>已經可以獨立開發腳本了！！</strong>
          </p>
        </div>
      </article>
    </div>
  </section>

  <section class="solutionband">
    <div class="solutionband__wrap">
      <p class="solutionband__p">
        全部影片是本人嘔心瀝血的作品組成，內容可以 終生訪問
      </p>
      <p class="solutionband__p">
        （後續6.0 - 7.0 ...版本更新可以繼續觀看）!!
      </p>
    </div>
  </section>

  <!-- 行動力橫幅（黑底金字） -->
  <section class="painstrip">
    <div class="painstrip__inner">
      限時免費大禮包
    </div>
    <div class="painstrip__inner">
      倒計時結束將全部消失
    </div>
  </section>

  <!-- ===== 大禮包 Section ===== -->
  <section class="bundle-section">
    <div class="bundle-wrap">
      <!-- 1) Web3小白養成之路 | 大禮包 -->
      <article class="bundle-card">
        <div class="bundle-media">
          <img src="/images/bundles/giftpack.png" alt="Web3 小白養成之路大禮包" loading="lazy">
        </div>
        <div class="bundle-body">
          <h3 class="bundle-title">
            Web3小白養成之路｜大禮包
            <span class="bundle-price">價值US$2,000</span>
          </h3>
          <p class="bundle-sub">（基礎素養與WEB3 行業觀點 &amp; 生存能力）</p>
          <ul class="bundle-list">
            <li><span class="check">✔</span> Web3小白養成之路｜清晰大路線（文檔 + 視頻）</li>
            <li><span class="check">✔</span> Web3加密101百科系列（筆記 + 視頻）</li>
            <li><span class="check">✔</span> 九步 從零到高薪系列（15條 + 視頻）</li>
            <li><span class="check">✔</span> Discord搭建運營教學系列（2條 + 視頻）</li>
          </ul>
          <p class="bundle-ps">
            ps：<strong>說明</strong>，有些系列是我多年沉澱與實戰，<strong class="warn">不屬於Web3軟體</strong>的
            純技術課，而是我對於行業與職涯的理解與<b>「大圖景」</b>，幫你在擇業與學習路線中少走彎路。
            內容含：學習方法、內部資料與工具。
          </p>
        </div>
      </article>

      <!-- 2) 院長支援大禮包 -->
      <article class="bundle-card">
        <div class="bundle-media">
          <img src="/images/bundles/giftpack.png" alt="院長支援大禮包" loading="lazy">
        </div>
        <div class="bundle-body">
          <h3 class="bundle-title">
            院長支援大禮包
            <span class="bundle-price">價值US$2,000</span>
          </h3>
          <p class="bundle-sub">（成長與問題排解）</p>
          <ul class="bundle-list">
            <li><span class="check">✔</span> 直接獲得我的系統觀點回覆，幫你問題尋找解決</li>
            <li><span class="check">✔</span> 黑馬養成化個人路徑，以及關鍵支援</li>
          </ul>
          <p class="bundle-ps">
            ps：限於「課後」學員持續精進，答疑類型；<b class="warn">能力導向的嚴選</b>！
          </p>
        </div>
      </article>

      <!-- 3) 社群大禮包 -->
      <article class="bundle-card">
        <div class="bundle-media">
          <img src="/images/bundles/giftpack.png" alt="社群大禮包" loading="lazy">
        </div>
        <div class="bundle-body">
          <h3 class="bundle-title">
            社群大禮包
            <span class="bundle-price">價值US$1,000</span>
          </h3>
          <p class="bundle-sub">（學員專屬Discord學習小組）</p>
          <ul class="bundle-list">
            <li><span class="check">✔</span> 每個學員都有一個「高黏度Discord群組」學伴相伴</li>
            <li><span class="check">✔</span> 共學-督學-作業交流，第三週~第八週交付成果</li>
            <li><span class="check">✔</span> 不是灌雞湯而是督導落地，避免半途放棄</li>
          </ul>
          <p class="bundle-ps">
            ps：群內<b class="warn">嚴格執行輸出數量</b>，互幫互督，習慣MBO的你！
          </p>
        </div>
      </article>
    </div>
  </section>

  <!-- 行動力橫幅（黑底金字） -->
  <section class="painstrip">
    <div class="painstrip__inner">
      以下就是你能獲得的全部價值
    </div>
  </section>

  <!-- ============== 你將獲得 (主清單) ============== -->
  <section class="bundle-offer">
    <div class="bo-wrap">
      <h2 class="bo-title">【立即加入課程！你將獲得！】</h2>

      <ul class="bo-list">
        <li class="bo-row">
          <span class="bo-name">EVM以太坊系列 - Solidity 開發課程</span>
          <span class="bo-price">價值$3800</span>
        </li>
        <li class="bo-row">
          <span class="bo-name">Solana 區塊鏈系列 - Seahorse 開發課程</span>
          <span class="bo-price">價值$3800</span>
        </li>
        <li class="bo-row">
          <span class="bo-name">Solana 區塊鏈系列 - 自動化腳本課程</span>
          <span class="bo-price">價值$3800</span>
        </li>
      </ul>

      <!-- 分隔 -->
      <div class="bo-sep"></div>

      <!-- ============== 行動紅利 ============== -->
      <h3 class="bo-subtitle">【現在行動紅利】</h3>
      <ul class="bo-list">
        <li class="bo-row">
          <span class="bo-name">Web3 養成大禮包</span>
          <span class="bo-price">價值US$2,000</span>
        </li>
        <li class="bo-row">
          <span class="bo-name">院長支援大禮包</span>
          <span class="bo-price">價值US$2,000</span>
        </li>
        <li class="bo-row">
          <span class="bo-name">社群大禮包</span>
          <span class="bo-price">價值US$1,000</span>
        </li>
      </ul>

      <!-- ============== 總價值 ============== -->
      <div class="bo-total">
        <span class="bo-total-label">總價值：</span>
        <span class="bo-total-currency">$</span>
        <span class="bo-total-amount">16,400</span>
      </div>
    </div>
  </section>

  <!-- ===== 柔金底課程卡片 Section ===== -->
  <OfferGoldCard />

  <!-- ============== 關於院長 / 介紹 Section ============== -->
  <section class="about-lead">
    <h2 class="syllabus-title" style="color: #000;">關於G大</h2>
    <div class="about-wrap">
      <!-- 左：形象圖 -->
      <figure class="about-media">
        <!-- 將 src 換成你的實際路徑 -->
        <img src="/images/gda-memoji.png" alt="G大 Memoji" loading="lazy" />
      </figure>

      <!-- 右：標題＋文案 -->
      <div class="about-body">
        <h2 class="about-title">某項目的開發總監・資深 Web3 個人創業者</h2>

        <p class="about-p">
          G大，是一名資深的 WEB3 個人創業者，曾經從業股票講師，以及量化交易策略開發工程師，
          現如今是某項目的聯合創始人，以及另一個項目的開發工程師（由於法規原因不能透露是什麼項目）。
        </p>

        <p class="about-p">
          他是一個對任何感興趣的事情，都能保持積極樂觀心態的人，是一個遇到挫折永不言敗、但也能靈活變通的人。
        </p>

        <p class="about-p">
          在這一路上，經歷過許多社會的毒打，遇過投資人撤資，也遇過技術壁壘、黑客攻擊，很遺憾，當時沒有一個老師能夠做路明燈，
          只能全憑努力，把項目需要的技能都學了一遍，造就了這種 WEB3 個人創業者的技能。
        </p>

        <p class="about-p">
          所以院長 G 大希望通過他的技能，能夠幫到需要這些技能度過人生存在難關的人。透過這裡，向有需要的觀眾分享。
        </p>
      </div>
    </div>
  </section>

  <!-- 行動力橫幅（黑底金字） -->
  <section class="painstrip">
    <div class="painstrip__inner">
      100%零風險，24小時無條件退款
    </div>
  </section>

  <!-- ============== 退款保障 / Guarantee Section ============== -->
  <section class="refund">
    <div class="refund-wrap">
      <!-- 左：徽章 -->
      <figure class="refund-badge">
        <!-- 換成你的實際路徑 -->
        <img src="/images/guarantee-badge.png" alt="100% Money Back Guarantee" loading="lazy">
      </figure>

      <!-- 中：文案 -->
      <div class="refund-body">
        <h3 class="refund-lead">好的產品經得起市場考驗，教育也是如此。</h3>

        <p class="refund-p">
          若你不滿意本課程的話，只需要在購買的
          <span class="red">24小時</span> 之內聯繫，我們將會 100% 無條件退款。
          因此你 <u class="bold">不需要承擔任何風險</u>。
        </p>

        <p class="refund-ps">
          Ps：課程完成度在 20% 以內，付款時間算起。
        </p>
      </div>

      <!-- 右：大標題 -->
      <h2 class="refund-title">我能退款嗎？</h2>
    </div>
  </section>

  <!-- 行動力橫幅（黑底金字） -->
  <section class="painstrip">
    <div class="painstrip__inner">
      常見問題Q&A
    </div>
  </section>


  <!-- ===== 柔金底課程卡片 Section ===== -->
  <OfferGoldCard />



  <!-- ============== FAQ / Q&A Section ============== -->
  <section class="faq">
    <div class="faq__wrap">
      <h2 class="faq__title">常見問題 Q&amp;A</h2>

      <!-- 1 -->
      <details class="faq__item">
        <summary class="faq__q">可以用支付寶 / 微信 / 銀行轉帳支付嗎？</summary>
        <div class="faq__a">
          <p>沒問題，上方包含支付寶/微信付費通道，點擊後會跳轉至《愛發電》平台進行付款，付款後會自動給你一個課程平台帳號。課程和學習課件都在那。</p>
        </div>
      </details>

      <!-- 2 -->
      <details class="faq__item">
        <summary class="faq__q">已經訂購課程，如何登入觀看？</summary>
        <div class="faq__a">
          <p>點擊本網站的右上角，輸入帳戶和密碼（你訂購時輸入的郵箱和預設密碼）即可登入。若忘記密碼，於登入頁「forgot password」以郵箱找回。</p>
        </div>
      </details>

      <!-- 3 -->
      <details class="faq__item">
        <summary class="faq__q">課程有固定時間嗎？有期限嗎？</summary>
        <div class="faq__a">
          <p>本課程沒有規定上課時間，並且為<strong>終身會員</strong>。你可任選時間上課且可隨時隨地永久觀看。我也會持續更新內容，讓你一路跟上。</p>
        </div>
      </details>

      <!-- 4 -->
      <details class="faq__item">
        <summary class="faq__q">本課程適合誰？</summary>
        <div class="faq__a">
          <ul class="faq__list">
            <li><span class="check">✔</span> 希望透過學習，能夠獨立開發 Web3 項目的朋友</li>
            <li><span class="check">✔</span> 希望自己的項目 Discord 社區有所突破的朋友</li>
            <li><span class="check">✔</span> 想學一門熱門開發技能、獲得高薪的朋友</li>
          </ul>
        </div>
      </details>

      <!-- 5 -->
      <details class="faq__item">
        <summary class="faq__q">本課程到底對我是否有效？</summary>
        <div class="faq__a">
          <p>本課為<strong>技術開發課程</strong>，提供教學案例下載。你可直接用我的案例代碼部署並發行項目。只要有恆心與行動力，當然對你有用。</p>
        </div>
      </details>

      <!-- 6 -->
      <details class="faq__item">
        <summary class="faq__q">本課程是否能保證我成功？</summary>
        <div class="faq__a">
          <p><strong>不承諾，也不保證。</strong>若你抱持「保證成功」的期待，請務必保持清醒。教程把重點內容與「輪子」彙整給你，但推動項目的人仍然是你。若你認為完成課程即可輕鬆成功，這套課程不適合你。</p>
        </div>
      </details>

      <!-- 7 -->
      <details class="faq__item">
        <summary class="faq__q">本課程不適合誰？</summary>
        <div class="faq__a">
          <ul class="faq__list">
            <li><span class="warn">⚠</span> 期待快速致富的人（世界上沒有任何「快速致富」計畫）。</li>
            <li><span class="warn">⚠</span> 沒有恆心與行動力的人。</li>
            <li><span class="warn">⚠</span> 習慣半途而廢的人。</li>
          </ul>
        </div>
      </details>

      <!-- 8 -->
      <details class="faq__item">
        <summary class="faq__q">我沒有編寫代碼基礎，能理解嗎？</summary>
        <div class="faq__a">
          <p>可以。課程從基礎代碼與運營立項教起，搭配實際項目例子；就算直接修改我提供的案例代碼，按步驟部署也能跑起來。</p>
          <p class="faq__note">建議仍具備一些 <strong>HTML / JS</strong> 基礎，會更好理解。</p>
        </div>
      </details>

      <!-- 9 -->
      <details class="faq__item">
        <summary class="faq__q">如果有不懂的地方怎麼辦？可以一對一諮詢嗎？</summary>
        <div class="faq__a">
          <p>可以。學習過程有任何問題，可直接私信我，院長本人親自解答，提供 1 對 1 服務。平日 <strong>09:00–16:00</strong> 較活躍；晚上若看到訊息也會回覆。</p>
        </div>
      </details>

      <!-- 10 -->
      <details class="faq__item">
        <summary class="faq__q">購課後可以退款嗎？</summary>
        <div class="faq__a">
          <p>若不滿意，<strong>付費後 24 小時內無條件退款</strong>，你不需要承擔任何風險。（課程完成率需在 <strong>20%</strong> 以內）</p>
          <p>實際上本課程退款率非常低，內容經得起考驗。</p>
        </div>
      </details>

      <!-- Contact -->
      <div class="faq__contact">
        <div class="faq__contact-item">
          <div class="k">院長 Email</div>
          <a class="v" href="mailto:web3schoolservice@gmail.com">web3schoolservice@gmail.com</a>
        </div>
        <div class="faq__contact-item">
          <div class="k">院長 Discord</div>
          <div class="v">gda_master</div>
        </div>
      </div>
    </div>
  </section>

  <section class="disclaimer-section">
    <div class="disclaimer-glass">
      <h2 class="disclaimer-title">免責聲明：</h2>
      <p class="disclaimer-text">
        這世界上並沒有真正的快速致富，也沒有人可以保證您的收益。所有的快速致富都無疑要建立在當事人的努力，勤奮之上。上面提到的任何成績，是我以及我學員的成績，習慣於努力的人始終不是大多數。
      </p>
      <p class="disclaimer-text">
        我重申，您的結果會有所不同，並取決於許多因素…包括但不限於您的背景，經驗和職業道德/態度。所有事業都伴隨著風險，以及需要大量與持續不斷的努力和行動。
      </p>
      <p class="disclaimer-text">
        如果您不願意接受，請不要購買我的課程。如有任何疑問，請通過
        <a href="mailto:web3schoolservice@gmail.com" class="mail-link">web3schoolservice@gmail.com</a> 聯繫我們。
      </p>
    </div>
  </section>
</template>

<script setup>
import OfferGoldCard from '../../src/plugins/offer-goldsoft/OfferGoldSoftCard.vue'

const thanks = [
  {
    src: '/images/testi/testi-1.png',
    alt: '學員回饋截圖 1',
    caption: '這兄弟有程式開發經驗，用2倍速快速-1天時間看完我們的實戰內容，終於把Solana的疑問全部解開！而且對課程內容給予高度肯定和評價！！'
  },
  {
    src: '/images/testi/testi-2.png',
    alt: '學員回饋截圖 2',
    caption: '這朋友是一名在校大學生，對Web3非常感興趣，自己搗鼓出一些成績，連忙來報喜... 也聊到我們的視頻的模式，雖然視頻精簡，但是特別有價值！'
  },
  {
    src: '/images/testi/testi-3.png',
    alt: '學員回饋截圖 3',
    caption: '這朋友2月8日買的課，惡補一周後，2月16日過了面試，面試的時候直接用我們第3章的實戰項目內容跟面試官介紹，下午就拿到了offer。 ✨'
  },
  {
    src: '/images/testi/testi-4.png',
    alt: '學員回饋截圖 4',
    caption: '這朋友是10年C語言的開發老兵，說他以前也報過其他課程，感覺他們的內容太長，講的太細，導致學起來很累。---而我們的課程，該有的都有，學習有反饋，每天學起來都有點進步，遇見問題也可以隨時請教！特意發來感謝！'
  },
  {
    src: '/images/testi/testi-5.png',
    alt: '學員回饋截圖 5',
    caption: '上面兄弟跟著我們的免費資料學習後收益良多，起初在外面東學1點西學一點的，甚至在web3領域都不知道自己應該學什麼，也不知道一個大型項目需要什麼知識，現在他已經找到大部隊，跟我們一起學習。'
  },
  {
    src: '/images/testi/testi-6.png',
    alt: '學員回饋截圖 6',
    caption: '上面哥們學了2-3星期，已經懂得合約發布和前端的鏈接，現在已經找我幫忙進行調試合約了。'
  },
  {
    src: '/images/testi/testi-7.png',
    alt: '學員回饋截圖 7',
    caption: '上面這哥們觀察了我們1個星期，最後還是選擇了我們課程，謝謝支持🙏'
  },
  {
    src: '/images/testi/testi-8.png',
    alt: '學員回饋截圖 8',
    caption: '學習遇到不懂🤔️，像這位朋友debug一樣，找我幫忙，我這邊也是1對1解答🤝，最後解決問題。'
  },
  {
    src: '/images/testi/testi-9.png',
    alt: '學員回饋截圖 9',
    caption: '我們基礎部分會教嗎？連環境依賴都手把手指定，放心...❤️'
  },
  {
    src: '/images/testi/testi-10.png',
    alt: '學員回饋截圖 10',
    caption: '這位學員我印象非常深刻，因為寄email給我而且還這麼多字的不多，謝謝大家對我的肯定'
  },
  {
    src: '',
    alt: '',
    caption: '...后面还有很多学员的信息我就不一一展示， 总的来说，好评如潮❤️❤️❤️！！！'
  }
]
// 想繼續加就往下放就好
</script>

<style scoped>
/* ==== 高亮字（速成 / 祕訣） ==== */
.hl,
.hl-text {
  background: linear-gradient(135deg, var(--brand-gold, #f7ce46), var(--brand-accent, #f08f2e));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* ===== Banner ===== */
.purchase-hero-glass {
  position: relative;
  width: 100%;
  min-height: 80vh;
  /* 稍高，卡片有空間 */
  display: flex;
  align-items: center;
  text-align: center;
  color: #fff;
  padding: 120px 0 72px;
  /* 底部多預留，避免卡片擠到邊緣 */
  background:
    linear-gradient(rgba(0, 0, 0, .42), rgba(0, 0, 0, .42)),
    url('/public/images/hero-bg.jpg') center/cover no-repeat;
  background-attachment: fixed;
  box-shadow: inset 0 0 90px rgba(0, 0, 0, .45);
}

.purchase-hero__overlay {
  position: absolute;
  inset: 0;
  background: radial-gradient(1100px 520px at 50% 45%,
      rgba(255, 255, 255, .16) 0%,
      rgba(255, 255, 255, .08) 30%,
      rgba(0, 0, 0, .45) 100%);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.purchase-hero__inner {
  position: relative;
  z-index: 2;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 標題置中 */
}

.purchase-hero__title {
  margin: 0 0 10px;
  font-weight: 900;
  line-height: 1.15;
  letter-spacing: .3px;
  font-size: clamp(28px, 4vw, 44px);
}

.purchase-hero__sub {
  margin: 0;
  font-size: clamp(15px, 1.8vw, 18px);
  line-height: 1.7;
  opacity: .95;
}

.purchase-hero__link {
  text-decoration: none;
}


/* ===== 白底區 ===== */
.declare-section {
  background: #fff;
  color: #0e1013;
  padding: 64px 0 56px;
}

.hero-declare {
  text-align: center;
  display: grid;
  gap: 10px;
  margin-bottom: 24px;
}

.hero-declare__title {
  margin: 0;
  font-weight: 900;
  font-size: clamp(22px, 4vw, 34px);
}

.hero-declare__sub {
  margin: 0;
  color: #333;
  font-size: clamp(14px, 2.2vw, 16px);
  line-height: 1.8;
}

.hero-declare__cta {
  font-size: 22px;
  font-weight: 900;
  color: #2ea44f;
}

.hero-media img {
  width: 100%;
  border-radius: 16px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, .12);
}

.aspect-video {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
}

.aspect-video iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

/* ===== 影片區字體 ===== */
.hero-video-title {
  margin: 100px 0 0;
  font-weight: 900;
  letter-spacing: .3px;
  /* ✅ 與 .hero-declare__title 相同字級 */
  font-size: clamp(22px, 4vw, 34px);
  line-height: 1.25;
  color: #0e1013;
  text-align: center;
}

.hero-video-sub {
  margin: 8px 0 16px 0;
  /* ✅ 與 .hero-declare__sub 相同字級 */
  font-size: clamp(14px, 2.2vw, 16px);
  line-height: 1.8;
  color: rgba(14, 16, 19, .72);
  text-align: center;
}

/* ===== 課程綱要：白色主題 + 居中900px ===== */
.syllabus-section {
  background: #fff;
  color: #0e1013;
  padding: 56px 0 64px;
  border-top: 1px solid rgba(0, 0, 0, .06);
  border-bottom: 1px solid rgba(0, 0, 0, .06);
}

.syllabus-container {
  max-width: 900px;
  /* ✅ 改為 900px */
  margin: 0 auto;
  padding: 0 20px;
}

.syllabus-title {
  text-align: center;
  font-weight: 900;
  font-size: clamp(22px, 4vw, 34px);
  margin-bottom: 32px;
}

/* ===== 每個 details 區塊 ===== */
.syllabus-item {
  margin-bottom: 22px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, .08);
  background: #fafafa;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, .04);
}

.syllabus-item[open] {
  background: #fff;
  box-shadow: 0 8px 20px rgba(0, 0, 0, .06);
}

/* summary 標題行 */
.syllabus-item>summary {
  cursor: pointer;
  list-style: none;
  font-weight: 800;
  font-size: 18px;
  padding: 14px 18px;
  background: #f5f5f7;
  border-bottom: 1px solid rgba(0, 0, 0, .06);
  user-select: none;
}

.syllabus-item>summary::-webkit-details-marker {
  display: none;
}

.syllabus-item>summary:hover {
  background: #efefef;
}

/* 章節內塊 */
.syllabus-block {
  padding: 16px 18px 6px;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, .04);
}

.syllabus-block:nth-child(even) {
  background: #fbfbfb;
  /* ✅ 模擬表格行底色交替 */
}

.syllabus-block h4 {
  font-weight: 700;
  font-size: 16px;
  margin: 0 0 6px;
  color: #111;
}

/* 課程列表 */
.syllabus-list {
  margin: 0 0 16px;
  padding-left: 22px;
  list-style: none;
}

.syllabus-list li {
  line-height: 1.7;
  font-size: 15px;
  padding: 3px 0;
}

/* RWD */
@media (max-width:1024px) {
  .offer-hero__grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .offer-hero__right {
    place-items: center;
  }

  .syllabus-list {
    columns: 2;
    /* 自動雙欄 */
  }

  .syllabus-list li {
    break-inside: avoid;
  }
}

/* ===== 聯繫院長 Section ===== */
.contact-section {
  background: #fff;
  color: #111;
  padding: 80px 0;
  text-align: center;
}

.contact-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 24px;
}

.contact-title {
  font-size: clamp(26px, 4vw, 40px);
  font-weight: 900;
  margin-bottom: 48px;
}

.contact-block {
  margin-bottom: 36px;
}

.contact-label {
  font-size: 18px;
  margin: 0;
}

.contact-email {
  font-size: 20px;
  font-weight: 700;
  color: #e74c3c;
  /* 紅色 */
  margin: 6px 0 0;
}

.contact-discord {
  font-size: 22px;
  font-weight: 700;
  color: #000;
  margin: 6px 0 0;
}

/* CTA Banner（金色文字） */
.cta-banner {
  width: 100%;
  background: #000;
  text-align: center;
  padding: 48px 16px;
}

.cta-banner h2 {
  margin: 0;
  font-size: clamp(20px, 3vw, 34px);
  font-weight: 800;
  color: #f7ce46;
  /* 金色字體 */
  letter-spacing: 1px;
}



/* ===== Dapp 方法 Section（深灰底、居中排版） ===== */
.dapp-method-band {
  background: #454c51;
  /* 深灰底，接近你的截圖 */
  padding: 64px 20px;
  color: #fff;
}

.dapp-method__wrap {
  max-width: 900px;
  /* 你要的 900 上限寬 */
  margin: 0 auto;
  text-align: center;
}

.dapp-method__title {
  margin: 0 0 18px 0;
  font-weight: 900;
  line-height: 1.25;
  letter-spacing: .3px;
  font-size: clamp(22px, 3.2vw, 34px);
}

.hl-gold {
  color: #f6c353;
  /* 金色高亮（與前面卡片金色系統一） */
}

.dapp-method__p {
  margin: 8px auto 0;
  font-size: clamp(14px, 1.8vw, 16px);
  line-height: 1.9;
  color: rgba(255, 255, 255, .92);
  /* 白字略降亮度，閱讀更柔和 */
}

/* =============== 第一段：深灰底 / 金色標題 =============== */
.painstrip {
  background: var(--black);
  padding: 60px 20px;
  text-align: center;
}

.painstrip__inner {
  max-width: 900px;
  margin: 0 auto;
  color: var(--gold);
  font-weight: 900;
  font-size: clamp(22px, 3vw, 30px);
  letter-spacing: 0.4px;
}

/* =============== 第二段：白底痛點清單 =============== */
.painbody {
  background: #fff;
  padding: 60px 20px 70px;
  color: var(--ink);
}

.painbody__wrap {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

.painbody__title {
  margin: 0 0 18px 0;
  font-weight: 900;
  line-height: 1.3;
  font-size: clamp(22px, 3vw, 36px);
  color: #27343a;
}

.painlist {
  list-style: none;
  padding: 0;
  margin: 20px auto 10px;
  max-width: 860px;
  text-align: left;
}

.painlist li {
  position: relative;
  display: block;
  padding-left: 28px;
  margin: 10px 0;
  font-size: clamp(15px, 2vw, 18px);
  line-height: 1.8;
  color: #22323a;
}

.painlist li::before {
  content: "✖";
  position: absolute;
  left: 0;
  top: 0.1em;
  font-weight: 900;
  color: #e35050;
}

.painbody__sub {
  margin-top: 24px;
  font-size: clamp(14px, 1.8vw, 18px);
  color: #2e3a41;
}

/* =============== 第三段：深灰解法帶 =============== */
.solutionband {
  background: var(--deep-gray);
  padding: 60px 20px;
  color: #fff;
  text-align: center;
}

.solutionband__wrap {
  max-width: 900px;
  margin: 0 auto;
}

.solutionband__title {
  margin: 0 0 16px 0;
  font-weight: 900;
  font-size: clamp(20px, 3vw, 30px);
  color: var(--gold);
}

.solutionband__p {
  margin: 8px auto 0;
  max-width: 860px;
  font-size: clamp(14px, 1.8vw, 16px);
  line-height: 1.9;
  color: rgba(255, 255, 255, 0.92);
}

/* ===== 上圖下文（全方位教學） ===== */
.teach-block {
  background: #f6f8fb;
  /* 很淺的灰藍底，貼近截圖 */
  border-top: 1px solid rgba(0, 0, 0, .05);
  border-bottom: 1px solid rgba(0, 0, 0, .05);
  padding: 56px 16px 64px;
}

.teach__wrap {
  max-width: 900px;
  /* 你要的 900px 上限 */
  margin: 0 auto;
}

.teach__figure {
  margin: 0 0 28px 0;
  display: grid;
  place-items: center;
}

.teach__figure img {
  width: 100%;
  max-width: 820px;
  /* 控制圖片最大寬，避免過寬擠壓文字 */
  height: auto;
  display: block;
  border-radius: 12px;
  /* 若不想圓角可刪除 */
}

/* 文字排版 */
.teach__content {
  color: #222e35;
  font-size: 16px;
  line-height: 1.95;
  letter-spacing: .2px;
}

.teach__content p {
  margin: 0 0 14px 0;
}

/* 背景與包裹 */
.thanks {
  background: #f6f6f8;
  padding: 80px 20px;
}

.thanks__wrap {
  max-width: 900px;
  /* 你之前要 900 寬 */
  margin: 0 auto;
  text-align: center;
}

.thanks__title {
  font-size: 2rem;
  font-weight: 800;
  color: #111;
  margin-bottom: 10px;
}

.thanks__arrows {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 28px;
}

.thanks__arrows .arr {
  width: 26px;
  height: 26px;
  color: #3b82f6;
}

/* Masonry：用 columns 做瀑布流 */
.thanks__masonry {
  column-gap: 14px;
  /* ✅ 收窄欄間距 */
  columns: 3 300px;
  /* ✅ 稍微放寬每欄寬度 */
  max-width: 920px;
  /* ✅ 整體寬度略大，貼近螢幕 */
  margin: 0 auto;
  /* ✅ 居中對齊 */
}

/* 卡片本體：用 inline-block + break-avoid 讓它在欄內當作一段 */
.card {
  display: inline-block;
  width: 100%;
  margin: 0 0 14px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  overflow: hidden;
  text-align: left;
  break-inside: avoid;
  -webkit-column-break-inside: avoid;
  -moz-column-break-inside: avoid;
  border: 1px solid #e9e9e9;
  transition: transform .2s ease, box-shadow .2s ease;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.1);
}

/* 圖片與說明 */
.card__media img {
  width: 100%;
  height: auto;
  display: block;
}

.card__cap {
  padding: 10px 14px 16px;
  font-size: 0.96rem;
  line-height: 1.7;
  color: #222;
}


/* “還有很多” */
.thanks__more {
  margin-top: 26px;
  color: #888;
  font-size: 1.05rem;
}

/* ===== 白底段落區 ===== */
.founder-note {
  background: #fff;
  color: #0e1013;
  padding: 56px 16px 36px;
  border-top: 1px solid rgba(0, 0, 0, .06);
}

.founder-note__wrap {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

.founder-note__wrap p {
  margin: 8px auto 0;
  /* ✅ 改成你指定的間距 */
  font-size: clamp(14px, 1.8vw, 16px);
  /* ✅ 改成更細緻的字體比例 */
  line-height: 1.9;
  /* ✅ 閱讀更順暢 */
  letter-spacing: .2px;
}

.founder-note__wrap strong {
  font-weight: 800;
}

/* ===== Section 背景：柔和漸層 + 微噪點 ===== */
.learn-pro {
  position: relative;
  padding: 64px 16px 56px;
  background:
    radial-gradient(1200px 600px at 20% -10%, rgba(242, 196, 78, .12), transparent 60%),
    radial-gradient(1000px 500px at 110% 20%, rgba(247, 206, 70, .10), transparent 60%),
    #ffffff;
  overflow: hidden;
  border-top: 1px solid rgba(0, 0, 0, .04);
}

.learn-pro::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(0, 0, 0, .04) 1px, transparent 1px);
  background-size: 12px 12px;
  opacity: .25;
  pointer-events: none;
}

.learn-pro__wrap {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

/* ===== Header ===== */
.pill {
  display: inline-block;
  padding: .35rem .7rem;
  border-radius: 999px;
  background: rgba(242, 196, 78, .16);
  color: #8a6b1a;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: .12em;
  text-transform: uppercase;
}

.learn-pro__head {
  text-align: center;
  margin-bottom: 26px;
}

.learn-pro__title {
  margin: .5rem 0 .25rem;
  font-weight: 900;
  letter-spacing: .3px;
  font-size: clamp(22px, 3.6vw, 36px);
  color: var(--ink);
}

.learn-pro__sub {
  margin: 8px auto 0;
  max-width: 680px;
  color: var(--muted);
  font-size: clamp(14px, 1.8vw, 16px);
  line-height: 1.9;
  /* 你要求的白底排版規格 */
}

/* ===== Grid ===== */
.learn-pro__grid {
  display: grid;
  grid-template-columns: 1.05fr .95fr;
  gap: 28px 36px;
  align-items: start;
}

/* ===== 左側卡片 ===== */
.lp-card {
  position: relative;
  display: flex;
  gap: 14px;
  padding: 16px 16px 16px 14px;
  border-radius: 18px;
  background: var(--glass);
  -webkit-backdrop-filter: blur(10px) saturate(130%);
  backdrop-filter: blur(10px) saturate(130%);
  border: 1px solid var(--glass-bd);
  box-shadow: var(--shadow);
  transition: transform .18s ease, box-shadow .18s ease;
  will-change: transform;
}

.lp-card+.lp-card {
  margin-top: 14px;
}

.lp-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 40px rgba(0, 0, 0, .16);
}

.lp-card__icon {
  flex: 0 0 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  background: linear-gradient(135deg, #fff8d9, #ffe48d);
  color: #b98500;
  border: 1px solid rgba(255, 255, 255, .8);
  box-shadow: 0 6px 14px rgba(0, 0, 0, .08) inset;
}

.lp-card__icon svg {
  width: 22px;
  height: 22px;
}

.lp-card__body {
  min-width: 0;
}

.lp-card__title {
  margin: 0 0 6px 0;
  font-weight: 900;
  font-size: clamp(16px, 2.1vw, 20px);
  color: var(--ink);
}

.lp-card__list {
  margin: 0;
  padding-left: 1.1em;
  color: var(--muted);
  font-size: clamp(14px, 1.8vw, 16px);
  line-height: 1.9;
  /* 白底規格 */
}

.lp-card__list li {
  margin: 2px 0;
}

/* 小提示 */
.learn-pro__note {
  margin: 12px 2px 0;
  color: #b12a1c;
  font-size: clamp(12px, 1.6vw, 14px);
}

/* ===== 右側：玻璃設備框 + 徽章 ===== */
.learn-pro__right {
  text-align: center;
}

.mock {
  position: relative;
  display: inline-block;
  padding: 16px;
  border-radius: 24px;
  background: rgba(255, 255, 255, .9);
  border: 1px solid rgba(0, 0, 0, .06);
  box-shadow: 0 16px 48px rgba(0, 0, 0, .12);
}

.mock::before {
  /* 簡易螢幕邊框 */
  content: "";
  position: absolute;
  inset: 10px;
  border-radius: 18px;
  border: 1px solid rgba(0, 0, 0, .06);
  pointer-events: none;
}

.mock__img {
  width: min(560px, 86vw);
  height: auto;
  display: block;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(0, 0, 0, .10);
}

.badge {
  position: absolute;
  top: -12px;
  right: -12px;
  display: inline-grid;
  place-items: center;
  width: 62px;
  height: 62px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, #ffec9c, #f1b82a 70%);
  color: #6b4b00;
  font-weight: 900;
  letter-spacing: .06em;
  border: 2px solid rgba(255, 255, 255, .9);
  box-shadow: 0 10px 24px rgba(0, 0, 0, .18);
}

.mock__cap {
  margin: 10px 0 0;
  color: var(--muted);
  font-size: 13px;
}

.course-sections {
  padding: 40px 16px 64px;
  background: #fff;
}

.course-wrap {
  max-width: 1200px;
  margin: 0 auto;
}

/* 單張卡片 */
.course-card {
  display: grid;
  grid-template-columns: 520px 1fr;
  /* 左圖右文 */
  gap: 28px;
  align-items: start;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 20px;
  box-shadow: 0 16px 46px rgba(0, 0, 0, .08);
  padding: 22px;
  margin-bottom: 38px;
}

.course-media img {
  width: 100%;
  height: auto;
  border-radius: 14px;
  display: block;
  box-shadow: 0 10px 24px rgba(0, 0, 0, .10);
}

/* 標題與副標 */
.course-head {
  margin-bottom: 8px;
}

.course-title {
  margin: 0;
  font-weight: 900;
  letter-spacing: .3px;
  color: var(--ink);
  font-size: clamp(20px, 3vw, 26px);
}

.course-title .price {
  color: var(--price);
  font-weight: 900;
}

.course-sub {
  margin: 4px 0 0;
  color: var(--muted);
  font-size: 13px;
}

/* 介紹行（勾勾） */
.course-intro {
  margin: 14px 0 14px;
  color: var(--muted);
  font-size: clamp(14px, 1.8vw, 16px);
  line-height: 1.9;
  /* 你的白底段落規格 */
}

.check {
  display: inline-grid;
  place-items: center;
  width: 18px;
  height: 18px;
  margin-right: 6px;
  color: #fff;
  background: var(--check);
  border-radius: 50%;
  font-size: 12px;
}

/* 小節標題 */
.course-section {
  margin: 6px 0 10px;
  color: var(--accent);
  font-weight: 900;
  letter-spacing: .03em;
  font-size: clamp(15px, 2vw, 18px);
}

/* 內容塊 */
.course-block {
  margin-bottom: 10px;
}

.course-label {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  background: #eef2ff;
  color: #4338ca;
  font-weight: 800;
  font-size: 12px;
  margin-bottom: 6px;
}

.course-text {
  margin: 0;
  color: var(--muted);
  font-size: clamp(14px, 1.8vw, 16px);
  line-height: 1.9;
  /* 白底段落規格 */
}

/* 附送連結與PS */
.course-link {
  margin: 10px 0 0;
  color: var(--violet);
  font-weight: 700;
}

.course-ps {
  margin: 6px 0 0;
  color: var(--pink);
  font-size: clamp(13px, 1.7vw, 15px);
}

/* ===== 大禮包 Section ===== */
.bundle-section {
  background: #fff;
  padding: 28px 0 8px;
}

.bundle-wrap {
  width: min(900px, 92vw);
  margin: 0 auto;
  display: grid;
  gap: 24px;
}

/* 卡片 */
.bundle-card {
  display: grid;
  grid-template-columns: 210px 1fr;
  gap: 18px;
  align-items: center;
  background: #fff;
  border-radius: 14px;
  border: 1px solid rgba(0, 0, 0, .06);
  box-shadow: 0 8px 24px rgba(0, 0, 0, .06);
  padding: 18px 20px;
}

.bundle-media {
  display: grid;
  place-items: center;
}

.bundle-media img {
  width: 180px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 6px 10px rgba(0, 0, 0, .12));
}

/* 文字 */
.bundle-title {
  margin: 0;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  font-size: clamp(18px, 2.2vw, 22px);
  font-weight: 800;
  letter-spacing: .2px;
  color: #111;
  /* 改成深黑色，白底清晰 */
}

.bundle-price {
  margin-left: 8px;
  font-weight: 900;
  color: #e53935;
  /* 紅色價格 */
  font-size: clamp(17px, 2vw, 20px);
  white-space: nowrap;
  /* 保證不斷行 */
}

/* 副標：灰色 */
.bundle-sub {
  margin: 6px 0 10px;
  font-size: 14px;
  color: #555;
}

/* 清單 */
.bundle-list {
  margin: 0 0 8px 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 6px;
  font-size: 15.5px;
  line-height: 1.8;
  color: #222;
  /* 白底主文字深灰黑 */
}

.bundle-list li {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.bundle-list .check {
  color: #2e7d32;
  /* 綠色核取標誌 */
  font-weight: 700;
  flex-shrink: 0;
  line-height: 1.2;
  font-size: 18px;
  margin-top: 2px;
  /* 垂直微調讓符號居中 */
}

/* ps 提示 */
.bundle-ps {
  margin: 6px 0 0;
  font-size: 12.5px;
  line-height: 1.8;
  color: #444;
}

.bundle-ps .warn {
  color: #c62828;
}

/* ===== Bundle Offer section ===== */
.bundle-offer {
  background: #fff;
  padding: 48px 0;
}

.bo-wrap {
  width: min(700px, 92vw);
  margin: 0 auto;
}

.bo-title {
  margin: 0 0 22px 0;
  text-align: center;
  font-weight: 900;
  color: #d6362a;
  /* 紅色主題 */
  font-size: clamp(22px, 3.6vw, 34px);
  letter-spacing: .5px;
}

.bo-subtitle {
  margin: 28px 0 12px 0;
  text-align: center;
  font-weight: 900;
  color: #d6362a;
  font-size: clamp(20px, 3vw, 30px);
}

.bo-sep {
  height: 22px;
}

.bo-list {
  list-style: none;
  padding: 0;
  margin: 0 0 8px 0;
  display: grid;
  gap: 14px;
}

.bo-row {
  display: grid;
  grid-template-columns: 1fr auto;
  /* 左內容、右價格 */
  align-items: center;
  gap: 16px;
  padding: 8px 4px;
}

.bo-name {
  font-size: clamp(16px, 2.2vw, 26px);
  font-weight: 800;
  color: #232323;
  /* 深灰更易讀 */
}

.bo-price {
  font-size: clamp(16px, 2.2vw, 26px);
  font-weight: 900;
  color: #3aa35b;
  /* 綠色價格 */
  white-space: nowrap;
}

/* 總價值 */
.bo-total {
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 10px;
  margin-top: 26px;
}

.bo-total-label {
  font-weight: 900;
  font-size: clamp(22px, 3vw, 36px);
  color: #111;
  letter-spacing: 2px;
}

.bo-total-currency {
  font-weight: 800;
  font-size: clamp(28px, 4vw, 44px);
  color: #111;
}

.bo-total-amount {
  font-weight: 900;
  font-size: clamp(34px, 5.2vw, 56px);
  color: #e53935;
  /* 大紅數字 */
  letter-spacing: 1px;
}

/* ========== Intro (左圖右文) ========== */
.about-lead {
  background: #fff;
  padding: clamp(36px, 6vw, 72px) 0;
}

.about-wrap {
  width: min(1200px, 92vw);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  /* 左圖略寬 */
  gap: clamp(24px, 4vw, 48px);
  align-items: center;
}

/* 圖片 */
.about-media {
  margin: 0;
}

.about-media img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 18px;
  box-shadow: 0 18px 40px rgba(0, 0, 0, .12);
  background: #f7f7f7;
  object-fit: cover;
}

/* 文字 */
.about-body {
  color: #111;
}

.about-title {
  margin: 0 0 14px 0;
  font-weight: 900;
  font-size: clamp(22px, 3.2vw, 34px);
  line-height: 1.3;
  letter-spacing: .2px;
}

.about-p {
  margin: 10px 0 0 0;
  font-size: clamp(14px, 1.8vw, 16px);
  line-height: 1.9;
  /* 你指定的白底正文排版 */
  color: #222;
}

/* ========== Refund / Guarantee ========== */
.refund {
  background: #fff;
  padding: clamp(36px, 6vw, 72px) 0;
}

.refund-wrap {
  width: min(1200px, 92vw);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 280px 1fr auto;
  /* 左徽章 / 中文案 / 右大標 */
  gap: clamp(20px, 4vw, 48px);
  align-items: center;
}

/* 徽章 */
.refund-badge {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.refund-badge img {
  width: clamp(160px, 22vw, 260px);
  height: auto;
  display: block;
}

/* 右側大標 */
.refund-title {
  margin: 0;
  font-weight: 900;
  font-size: clamp(22px, 3.6vw, 46px);
  color: #111;
  white-space: nowrap;
}

/* 文案 */
.refund-body {
  color: #111;
}

.refund-lead {
  margin: 0 0 10px 0;
  font-weight: 800;
  color: #2f6fe0;
  /* 藍色引導句 */
  font-size: clamp(16px, 2.2vw, 24px);
  line-height: 1.5;
}

.refund-p {
  margin: 8px auto 0;
  font-size: clamp(14px, 1.8vw, 16px);
  line-height: 1.9;
  color: #222;
}

.refund-ps {
  margin-top: 8px;
  font-size: clamp(13px, 1.6vw, 15px);
  line-height: 1.8;
  color: #c2302a;
  /* 紅色 PS */
}

/* 強調 */
.red {
  color: #d73d32;
  font-weight: 800;
}

.bold {
  font-weight: 900;
}

.disclaimer-section {
  padding: 60px 20px;
  background: radial-gradient(ellipse at center, rgba(255, 255, 255, 0.05), rgba(0, 0, 0, 0.6));
  display: flex;
  justify-content: center;
  align-items: center;
}

.disclaimer-glass {
  max-width: 900px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  padding: 40px 50px;
  color: #fff;
  line-height: 1.8;
  font-size: 1rem;
  text-align: justify;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.3);
}

.disclaimer-title {
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #ffd700;
  text-align: center;
}

.mail-link {
  color: #ffd700;
  font-weight: 600;
  text-decoration: none;
}

.mail-link:hover {
  text-decoration: underline;
}

/* ========== FAQ / Q&A ========== */
.faq {
  background: #fff;
  padding: clamp(36px, 6vw, 72px) 0;
}

.faq__wrap {
  width: min(900px, 92vw);
  margin: 0 auto;
}

.faq__title {
  margin: 0 0 16px 0;
  text-align: center;
  font-weight: 900;
  font-size: clamp(22px, 3vw, 32px);
  color: #111;
}

/* 單題 */
.faq__item {
  background: #f7f8fb;
  border: 1px solid rgba(0, 0, 0, .06);
  border-radius: 14px;
  padding: 0;
  margin: 12px 0;
  overflow: hidden;
}

.faq__item[open] {
  background: #f5f7ff;
  border-color: rgba(47, 111, 224, .2);
  box-shadow: 0 6px 20px rgba(0, 0, 0, .06);
}

.faq__q {
  list-style: none;
  cursor: pointer;
  padding: 16px 18px;
  font-weight: 800;
  color: #0f172a;
  position: relative;
  font-size: clamp(15px, 2vw, 18px);
}

.faq__q::-webkit-details-marker {
  display: none;
}

.faq__q::before {
  content: "Q";
  display: inline-grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  margin-right: 10px;
  font-weight: 900;
  font-size: 12px;
  color: #111;
  background: linear-gradient(135deg, #ffe796, #f2c04a);
  border: 1px solid rgba(0, 0, 0, .08);
}

.faq__q::after {
  content: "+";
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-weight: 900;
  color: #111;
  opacity: .6;
}

.faq__item[open] .faq__q::after {
  content: "–";
}

.faq__a {
  padding: 0 18px 16px 18px;
  color: #222;
  font-size: clamp(14px, 1.8vw, 16px);
  line-height: 1.9;
}

.faq__a p {
  margin: 10px 0 0 0;
}

.faq__note {
  color: #555;
}

/* 列表與標記 */
.faq__list {
  margin: 10px 0 0 0;
  padding-left: 0;
  list-style: none;
}

.faq__list li {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin: 6px 0;
}

.check {
  color: #2ea44f;
  font-weight: 900;
}

.warn {
  color: #d73d32;
  font-weight: 900;
}

/* 聯絡 */
.faq__contact {
  margin-top: 18px;
  border-top: 1px dashed rgba(0, 0, 0, .12);
  padding-top: 14px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 20px;
}

.faq__contact-item .k {
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 4px;
}

.faq__contact-item .v {
  color: #1e293b;
  word-break: break-all;
}

.faq__contact a.v {
  color: #2563eb;
  text-decoration: none;
}

.faq__contact a.v:hover {
  text-decoration: underline;
}

.syllabus-separator {
  text-align: center;
  margin: 80px 0;
  /* padding: 32px 0; */
}

.syllabus-separator img {
  /* width: 90%; */
  /* max-width: 600px; */
  opacity: 0.95;
}

/* 🔧 修正手機畫面下金色卡片過寬／超出螢幕 */
@media (max-width: 720px) {

  /* 整個 Banner 高度調低，避免卡片超出底部 */
  .purchase-hero-glass {
    min-height: 500px;
    padding: 90px 0 80px;
  }

  /* 讓卡片寬度不超出螢幕、保持左右留白 */
  .offer-hero__panel {
    width: calc(100% - 32px);
    /* 左右各留 16px */
    margin: 32px auto 0;
    padding: 20px 16px;
    border-radius: 18px;
  }

  /* 內部改為上下排列，避免壓縮 */
  .offer-hero__grid {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    gap: 20px;
  }

  /* 倒數膠囊置中、縮小間距 */
  .pill-cd {
    justify-content: center;
    flex-wrap: wrap;
    padding: 10px 12px;
    gap: 10px;
    transform: scale(0.9);
  }

  .purchase-hero__inner {
    margin-top: 100px;
  }

  .syllabus-section {
    padding: 44px 0 52px;
  }

  .syllabus-item>summary {
    font-size: 16px;
    padding: 12px 14px;
  }

  .syllabus-item h4 {
    margin: 14px 14px 6px;
    font-size: 15px;
  }

  .syllabus-list {
    margin: 0 14px 10px;
    padding-left: 16px;
    columns: 1;
  }

  .syllabus-list li {
    font-size: 14px;
  }

  .contact-section {
    padding: 60px 0;
  }

  .contact-title {
    font-size: 30px;
  }

  .contact-section {
    padding: 60px 0;
  }

  .contact-title {
    font-size: 30px;
  }


  /* ===== Dapp 方法 Section（深灰底、居中排版） ===== */
  .dapp-method-band {
    padding: 48px 16px;
  }

  .dapp-method__title {
    font-size: 22px;
  }

  .painstrip {
    padding: 44px 16px;
  }

  .painbody {
    padding: 40px 16px 50px;
  }

  .solutionband {
    padding: 44px 16px;
  }

  /* ===== 上圖下文（全方位教學） ===== */
  .teach-block {
    padding: 40px 14px 48px;
  }

  .teach__content {
    font-size: 15.5px;
    line-height: 1.9;
  }

  .thanks__masonry {
    columns: 1;
    max-width: 420px;
  }

  .founder-note {
    padding: 44px 14px 28px;
  }

  .convince-band {
    padding: 36px 14px 44px;
  }

  .convince-band__wrap {
    max-width: 900px;
  }

  .learn-pro {
    padding: 48px 14px 40px;
  }

  .lp-card {
    padding: 14px;
    border-radius: 16px;
  }

  .lp-card__icon {
    flex-basis: 38px;
    height: 38px;
    border-radius: 10px;
  }

  .badge {
    transform: scale(.9);
  }

  .course-card {
    grid-template-columns: 1fr;
    padding: 18px;
  }

  .course-media img {
    border-radius: 12px;
  }


  .bundle-card {
    grid-template-columns: 1fr;
    text-align: left;
    padding: 16px;
  }

  .bundle-media img {
    width: 140px;
  }

  .bo-wrap {
    width: min(640px, 94vw);
  }

  .bo-row {
    padding: 6px 0;
  }

  .bo-name {
    font-weight: 800;
  }

  .bo-price {
    font-weight: 900;
  }

  .bo-total {
    gap: 8px;
  }

  .about-wrap {
    grid-template-columns: 1fr;
  }

  .about-media {
    order: -1;
  }

  /* 圖片在上 */
  .refund-wrap {
  grid-template-columns: 1fr;
  text-align: center;
}

.refund-title {
  order: -1;
  white-space: normal;
}

.refund-badge {
  order: 0;
}

.refund-body {
  order: 1;
}

.disclaimer-glass {
  padding: 30px 20px;
  font-size: 0.95rem;
}

.disclaimer-title {
  font-size: 1.3rem;
}

.faq__contact {
  grid-template-columns: 1fr;
}

.learn-pro {
    padding: 44px 14px 40px;
  }

  /* Header */
  .learn-pro__head { margin-bottom: 18px; }
  .pill {
    font-size: 11px;
    padding: .3rem .65rem;
  }
  .learn-pro__title {
    letter-spacing: .2px;
    font-size: 22px;            /* clamp 的下限已是 22px，這裡鎖定更穩 */
    margin: .45rem 0 .2rem;
  }
  .learn-pro__sub {
    max-width: 92%;
    font-size: 14px;
    line-height: 1.8;
  }

  /* Grid → 單欄堆疊 */
  .learn-pro__grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    align-items: stretch;
  }

  /* 左側卡片 */
  .lp-card {
    gap: 12px;
    padding: 14px 12px;
    border-radius: 16px;
    box-shadow: var(--shadow);
    transform: none !important;         /* 手機移除 hover 浮起 */
  }
  .lp-card + .lp-card { margin-top: 12px; }

  .lp-card__icon {
    flex: 0 0 36px;
    height: 36px;
    border-radius: 10px;
  }
  .lp-card__icon svg {
    width: 18px;
    height: 18px;
  }

  .lp-card__title {
    font-size: 16px;                    /* clamp 下限 */
    margin: 0 0 4px;
  }

  .lp-card__list {
    padding-left: 1em;
    font-size: 14px;
    line-height: 1.8;
  }
  .lp-card__list li { margin: 1px 0; }

  .learn-pro__note {
    margin: 10px 2px 0;
    font-size: 12px;
  }

  /* 右側拼貼圖 */
  .learn-pro__right { margin-top: 6px; }

  .mock {
    position: relative;
    width: 100%;
  }
  .mock__img {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 14px;
  }
  .mock__cap {
    margin-top: 8px;
    font-size: 12px;
    line-height: 1.7;
    color: var(--muted);
  }

  /* 熱門徽章（若桌面是絕對定位，這裡縮小並貼邊） */
  .mock .badge {
    position: absolute;
    top: 8px;
    right: 8px;
    padding: 4px 8px;
    font-size: 11px;
    border-radius: 999px;
    transform: none !important;
  }
}



</style>
